angular.module("registrace")

    .controller('RegistraceCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function ($scope, $http, $location, api, Registrace, Container) {

        $scope.formData = {komodita:'utility'};
        $scope.blured = {};

        $scope.deaktivateApp = deaktivateApp;

        if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
            api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
            return;
        }

        $scope.setBlured = function (elem, blured) {
            $scope.blured[elem] = blured;
        };

        $scope.isBlured = function (elem) {
            return !!$scope.blured[elem];
        };

        $scope.data = {
            customized: false,
            loading: false
        };

        var init = function () {

            if (location.search.match(/zpnd/) || location.search.match(/cdi/)) {
                api.logAnonymousAppAction('REGISTRACE-PND', '', '', '');
                $scope.data.customized = true;
                Container.setCustomized();
            } else {
                api.logAnonymousAppAction('REGISTRACE', '', '', '');
            }
        };

        init();



        $scope.processForm = function () {
            Container.setBasicInfo($scope.formData);
            $scope.data.loading = true;


            Registrace.registerStep1($scope.formData)
                .success(function (response) {

                    var message;
                    api.cleanMessages();

                    if (response && (response.loginStatus !== null) && (response.loginStatus === 0)) {
                        $scope.data.loginList = response.loginList;
                        message = {
                            type: 'WARN',
                            text: 'Zadaný login není možné použít.',
                            id: 'NG-REG',
                            num: "001"
                        };
                        api.addMessage(message);
                    } else {
                        Container.setCompany(response.company);
                        $location.path("/dokonceni");
                    }
                    $scope.data.loading = false;
                })

                .error(function (response) {
                    $scope.data.loading = false;
                });
        };
        

    }]);